import { Component } from '@angular/core';

@Component({
	selector: 'seira-listagem-notificacoes-tab',
	templateUrl: './listagem-notificacoes-tab.component.html',
	styleUrls: ['./listagem-notificacoes-tab.component.scss'],
})
export class ListagemNotificacoesTabComponent {}
